import GalleryXR from 'components/GalleryXR/GalleryXR'

function GalleryXRPage () {
  return (
    <div className="App">
      <GalleryXR />
    </div>
  )
}

export default GalleryXRPage
